import React from 'react';

import clx from 'classnames';

import styles from './Field.module.scss';

interface FieldProps {
    bottomNote?: React.ReactNode;
    error?: string;
    fieldDescription?: React.ReactNode;
    fieldTitle: React.ReactNode;
    required?: boolean;
    containerClassName?: string;
    contentClassName?: string;
    size?: 'm' | 'l';
}

export const Field: React.FC<FieldProps> = ({
    children,
    error,
    required,
    bottomNote,
    fieldTitle,
    fieldDescription,
    containerClassName,
    contentClassName,
    size = 'l',
}) => {
    return (
        <div className={clx(styles.formFieldContainer, containerClassName)}>
            <h4
                className={clx(
                    styles.formFieldTitle,
                    size === 'l' && styles.formFieldTitle_sizeL,
                    size === 'm' && styles.formFieldTitle_sizeM,
                )}
            >
                {fieldTitle} {required && <span className={styles.formFieldAsterisk}>*</span>}
            </h4>
            {fieldDescription && <div className={styles.formFieldDescription}>{fieldDescription}</div>}
            <div className={clx(contentClassName)}>
                {children}
                {error && <div className={styles.formFieldError}>{error}</div>}
                {bottomNote && <div className={styles.formFieldDescription}>{bottomNote}</div>}
            </div>
        </div>
    );
};
